import { jsx as e } from "react/jsx-runtime";
import f from "classnames";
import * as n from "@radix-ui/react-tabs";
import p from "./index.es5623.js";
import { BaseTabsContext as T } from "./index.es5624.js";
import { findFirstId as b } from "./index.es548.js";
import { BaseTabList as l } from "./index.es5625.js";
import { BaseTabTrigger as d } from "./index.es5626.js";
import { BaseTabContent as g } from "./index.es5627.js";
const r = ({
  hasBrandColor: o,
  defaultTab: a,
  onTabChange: s,
  children: t,
  testId: m,
  variant: i
}) => /* @__PURE__ */ e(T.Provider, { value: { variant: i, hasBrandColor: o }, children: /* @__PURE__ */ e(
  n.Root,
  {
    "data-testid": m,
    className: f({
      [p.brandColorBaseLine]: o
    }),
    defaultValue: a ?? b(t),
    onValueChange: s,
    children: t
  }
) });
r.List = l;
r.Trigger = d;
r.Content = g;
export {
  r as BaseTabs
};
//# sourceMappingURL=index.es901.js.map
